import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, Sparkles } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { interdanzaProgram, arteNaturaEvents, contactInfo } from "../mock/mock";

const Novita = () => {
  const { t, pick } = useLang();
  const arteFeature = arteNaturaEvents[arteNaturaEvents.length - 1];

  return (
    <div>
      <PageHero
        image="https://images.unsplash.com/photo-1465847899084-d164df4dedc6"
        kicker={t("common.current")}
        title={t("news.title")}
        lead={t("news.lead")}
      />

      <section className="bg-[#faf7f2] py-20 lg:py-28 space-y-8">
        {/* Interdanza feature */}
        <div className="mx-auto max-w-6xl px-5 lg:px-8">
          <Reveal className="bg-white border border-[#eae4d9] overflow-hidden lg:grid lg:grid-cols-2">
            <div className="aspect-[16/11] lg:aspect-auto overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_arte-natura-hub/artifacts/ohwa3qde_DSC8942.jpg"
                alt="Interdanza 2026"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <span className="inline-flex items-center gap-2 text-[#b5533a] text-xs uppercase tracking-[0.2em]">
                <Calendar className="w-4 h-4" /> {t("interdanza.currentDates")}
              </span>
              <h2 className="mt-3 font-serif text-3xl md:text-4xl text-[#1c1b1a]">
                {t("interdanza.currentTitle")}
              </h2>
              <p className="mt-4 text-[#3d3a35] leading-relaxed">
                {t("interdanza.currentText")}
              </p>
              <ul className="mt-5 space-y-2">
                {interdanzaProgram.slice(0, 3).map((p, i) => (
                  <li key={i} className="flex gap-2 text-sm text-[#6a655c]">
                    <Sparkles className="w-4 h-4 text-[#b5533a] shrink-0 mt-0.5" />
                    {pick(p)}
                  </li>
                ))}
              </ul>
              <Link
                to="/interdanza"
                className="mt-7 inline-flex items-center gap-2 text-[#b5533a] text-sm uppercase tracking-[0.14em] hover:gap-3 transition-all"
              >
                {t("common.readMore")} <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </Reveal>
        </div>

        {/* Arte e Natura feature */}
        {arteFeature && (
          <div className="mx-auto max-w-6xl px-5 lg:px-8">
            <Reveal className="bg-white border border-[#eae4d9] overflow-hidden lg:grid lg:grid-cols-2">
              <div className="p-8 lg:p-12 flex flex-col justify-center order-2 lg:order-1">
                <span className="inline-flex items-center gap-2 text-[#b5533a] text-xs uppercase tracking-[0.2em]">
                  {t("arteNatura.eventsSubtitle")}
                </span>
                <h2 className="mt-3 font-serif text-3xl md:text-4xl text-[#1c1b1a]">
                  {t("arteNatura.title")}
                </h2>
                <p className="mt-4 text-[#3d3a35] leading-relaxed">{t("arteNatura.overviewP1")}</p>
                <Link
                  to="/arte-e-natura"
                  className="mt-7 inline-flex items-center gap-2 text-[#b5533a] text-sm uppercase tracking-[0.14em] hover:gap-3 transition-all"
                >
                  {t("common.readMore")} <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
              <div className="aspect-[16/11] lg:aspect-auto overflow-hidden order-1 lg:order-2">
                <img
                  src={arteFeature.image}
                  alt={pick(arteFeature.title)}
                  className="w-full h-full object-cover"
                />
              </div>
            </Reveal>
          </div>
        )}
      </section>
    </div>
  );
};

export default Novita;
